import RestResource from '../rest.service';
import Service from '../api.service';

export default class QuotationItemsService extends RestResource {
  map(payload) {
    return {
      article_id: payload.article ? payload.article.id : null,
      quantity: payload.quantity,
      unit_price: payload.price,
    };
  }

  setQuotation(quotationId) {
    this.parents = [];
    this.parents.push(quotationId);
    return this;
  }

  get(params = {}) {
    return Service.get('quotations-items', { params: params }).catch(this.handleErrors);
  }

  constructor() {
    super('quotations/$0/items');
  }
}
